import { Message, Segment } from "semantic-ui-react";
import QRCode from "react-qr-code";

const AdminPaymentSlug = ({ payment_slug }) => {
  if (!payment_slug) return null;

  const url = `${window.location.origin}/pay/${payment_slug}`;

  return (
    <>
      <Segment basic textAlign="center">
        <Message info>
          <Message.Header>Betallänk</Message.Header>
          <Message.Content>
            <a href={url} target="_blank" rel="noreferrer">
              {url}
            </a>
          </Message.Content>
        </Message>
        <br />
        <p>Alternativt kan du scanna QR-koden nedan:</p>
        <br />
        <QRCode value={url} style={{ width: "40%", height: "auto" }} />
      </Segment>
    </>
  );
};

export default AdminPaymentSlug;
